/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Department } from '../model/department';
import { DepartmentCreateRequest } from '../model/departmentCreateRequest';
import { DepartmentKeys } from '../model/departmentKeys';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createDepartment
     * Creates a new department.
     * @param departmentCreateRequest the information needed to create the department
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public departmentCreateDepartment(departmentCreateRequest: DepartmentCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<Department>;
    public departmentCreateDepartment(departmentCreateRequest: DepartmentCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Department>>;
    public departmentCreateDepartment(departmentCreateRequest: DepartmentCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Department>>;
    public departmentCreateDepartment(departmentCreateRequest: DepartmentCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (departmentCreateRequest === null || departmentCreateRequest === undefined) {
            throw new Error('Required parameter departmentCreateRequest was null or undefined when calling departmentCreateDepartment.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Department>(`${this.configuration.basePath}/departments`,
            departmentCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteDepartment
     * Deletes an existing department by department code.
     * @param departmentCode the department code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public departmentDeleteDepartment(departmentCode: string, observe?: 'body', reportProgress?: boolean): Observable<Department>;
    public departmentDeleteDepartment(departmentCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Department>>;
    public departmentDeleteDepartment(departmentCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Department>>;
    public departmentDeleteDepartment(departmentCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (departmentCode === null || departmentCode === undefined) {
            throw new Error('Required parameter departmentCode was null or undefined when calling departmentDeleteDepartment.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Department>(`${this.configuration.basePath}/departments/${encodeURIComponent(String(departmentCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDepartment
     * Gets an existing department by department code.
     * @param departmentCode the department code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public departmentGetDepartment(departmentCode: string, observe?: 'body', reportProgress?: boolean): Observable<Department>;
    public departmentGetDepartment(departmentCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Department>>;
    public departmentGetDepartment(departmentCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Department>>;
    public departmentGetDepartment(departmentCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (departmentCode === null || departmentCode === undefined) {
            throw new Error('Required parameter departmentCode was null or undefined when calling departmentGetDepartment.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Department>(`${this.configuration.basePath}/departments/${encodeURIComponent(String(departmentCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDepartments
     * Gets a list of department keys for all departments defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public departmentGetDepartments(observe?: 'body', reportProgress?: boolean): Observable<DepartmentKeys>;
    public departmentGetDepartments(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DepartmentKeys>>;
    public departmentGetDepartments(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DepartmentKeys>>;
    public departmentGetDepartments(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DepartmentKeys>(`${this.configuration.basePath}/departments`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
